<div class="detail-page">
  <div class="page-header">
    <div class="header-text">
      <button type="button" class="back-btn" (click)="backTo()" aria-label="Voltar">
        <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
      </button>
      <div class="header-text__copy">
        <div class="header-text__title-row">
          <h2>
            {{
              isMaintenance
                ? 'Solicitação de manutenção'
                : checklistHeader?.ProductModel?.name || 'Checklist'
            }}
          </h2>
          @if (checklistHeader) {
            <nz-tag [nzColor]="statusInfo.color">{{ statusInfo.text }}</nz-tag>
          }
        </div>
        <p>
          @if (checklistHeader) {
            @if (isMaintenance) {
              {{ checklistHeader.ProductModel.name || 'Veículo' }}
              ·
              <span class="plate">{{ checklistHeader.chassis | uppercase }}</span>
              · #{{ checklistHeader.id }}
            } @else {
              {{ checklistHeader.chassis | uppercase }} · #{{ checklistHeader.id }}
            }
          } @else {
            Carregando detalhes…
          }
        </p>
      </div>
    </div>

    <div class="header-actions">
      <button nz-button nzType="default" (click)="generatePdf()">
        <i nz-icon nzType="file-pdf"></i>
        PDF
      </button>
      <button
        nz-button
        nzType="default"
        (click)="editHeaderModal.handleOpen(checklistHeader)"
      >
        <i nz-icon nzType="edit"></i>
        Editar
      </button>
      <button
        nz-button
        nzType="primary"
        [disabled]="checklistHeader?.status !== 'in_progress'"
        nz-popconfirm
        [nzPopconfirmTitle]="
          isMaintenance
            ? 'Deseja finalizar esta solicitação de manutenção?'
            : 'Deseja mesmo finalizar este check-list?'
        "
        nzPopconfirmPlacement="bottom"
        (nzOnConfirm)="confirm(StatusEnum.DONE)"
        nzPopconfirmCancelText="Não"
        (nzOnCancel)="cancel()"
      >
        <i nz-icon nzType="check"></i>
        Finalizar
      </button>
      <button
        nz-button
        nzType="default"
        class="btn-danger-outline"
        [disabled]="checklistHeader?.status !== 'in_progress'"
        nz-popconfirm
        [nzPopconfirmTitle]="
          isMaintenance
            ? 'Deseja cancelar esta solicitação de manutenção?'
            : 'Deseja mesmo cancelar este check-list?'
        "
        nzPopconfirmPlacement="bottom"
        (nzOnConfirm)="confirm(StatusEnum.CANCELED)"
        nzPopconfirmCancelText="Não"
        (nzOnCancel)="cancel()"
      >
        <i nz-icon nzType="close"></i>
        Cancelar
      </button>
      @if (isMaintenance && checklistHeader) {
        <button
          nz-button
          nzType="default"
          (click)="notProceedModal.handleOpen(checklistHeader)"
        >
          <i nz-icon nzType="warning"></i>
          Não procede
        </button>
      }
    </div>
  </div>

  <div class="detail-body">
    @if (checklistHeader) {
      <az-item-component
        [checklistHeader]="checklistHeader"
        [checklistFound]="checklistFound"
        (edited)="handleSearchChecklist(checklistHeaderId)"
      ></az-item-component>
    }
  </div>
</div>

<app-edit-header
  #editHeaderModal
  (onHeaderEdited)="handleEditChecklistHeader(checklistHeader)"
></app-edit-header>

<app-not-proceed
  #notProceedModal
  (onNotProceed)="handleNotProceed(checklistHeader)"
></app-not-proceed>
